import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import styles from "./recuperation.module.css";
import SocialLogin from "../SocialLogin/SocialLoginComponent";
import { RecuperationProps } from "@/types/RecuperationType";
import { ArrowLeft } from "lucide-react";
import { UiButton } from "../ui";

const FormulaireRecuperation: React.FC<RecuperationProps> = ({
  titre,
  sousTitre,
  image,
  onSubmit,
  onResendCode,
  isCodePage = false,
  error,
  loading = false,
}) => {
  const validationSchema = Yup.object({
    valeur: isCodePage
      ? Yup.string()
          .required("Le code est requis")
          .matches(/^\d{8}$/, "Le code doit être composé de 8 chiffres")
      : Yup.string()
          .required("L'email ou le matricule est requis")
          .test(
            "email-or-matricule",
            (value) => {
              if (value.includes("@")) {
                return "L'email doit être valide";
              } else {
                return "Le matricule doit contenir exactement 5 caractères (chiffres et lettres uniquement)";
              }
            },
            (value) => {
              if (value.includes("@")) {
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
              } else {
                return /^[A-Za-z0-9]{5}$/.test(value);
              }
            }
          ),
  });

  const formik = useFormik({
    initialValues: {
      valeur: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const type = isCodePage ? "code" : "email";
      onSubmit(values.valeur, type);
    },
  });

  const isButtonDisabled = !formik.values.valeur || !!formik.errors.valeur;

  return (
    <div className={styles.container}>
      <div className={styles.leftColumn}>
        <div className=" mt-1 pl-4">
          <Link
            to="/connexion"
            style={{
              fontSize: "0.875rem",
              display: "inline-flex",
              alignItems: "center",
              gap: "0.25rem",
            }}
          >
            <ArrowLeft size={14} />
            connexion
          </Link>
        </div>
        <h2 className={styles.title}>{titre}</h2>
        <p className={styles.subtitle}>{sousTitre}</p>

        <form onSubmit={formik.handleSubmit} className={styles.form}>
          <input
            type="text"
            name="valeur"
            placeholder={
              isCodePage
                ? "Entrez le code reçu"
                : "Entrez votre email ou matricule"
            }
            value={formik.values.valeur}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={styles.input}
          />

          {formik.touched.valeur && formik.errors.valeur && (
            <p className={styles.erreur}>{formik.errors.valeur}</p>
          )}

          <UiButton
            type="submit"
            className={styles.button}
            disabled={isButtonDisabled}
            loading={loading}
          >
            {isCodePage ? "Vérifier le code" : "Envoyer le code"}
          </UiButton>
          {error && <p className={styles.erreurGlobal}>{error}</p>}
          {isCodePage && onResendCode && (
            <div className={styles.resendCodeContainer}>
              <button
                type="button"
                onClick={onResendCode}
                className={styles.resendButton}
              >
                <span className={styles.blackText}>Pas reçu le code ?</span>
                <span className={styles.blueText}>
                  {" "}
                  Vérifiez vos spams ou renvoyez-le.
                </span>
              </button>
            </div>
          )}
        </form>
        <div style={{ marginTop: "1rem" }}>
          <SocialLogin />
        </div>
      </div>

      <div className={styles.rightColumn}>
        <img src={image} alt="Illustration" className={styles.mainImage} />
      </div>
    </div>
  );
};

export default FormulaireRecuperation;
